import type { Breakpoint } from '@mui/material';

export const breakpoint: Breakpoint = 'sm';
